import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { UiButtonDirective } from '@template-ui/directives';
import type {
  NoticeCatalog,
  NoticeComposition,
  NoticeDiagnostic,
} from './notice-fidelity.models';
import {
  resolveDiagnosticTarget,
  type NoticeDiagnosticNavigation,
  type NoticeDiagnosticResolution,
  type NoticeDiagnosticTarget,
} from './notice-diagnostic-navigation';

/** Compact presentation of authoritative diagnostics; all corrections stay with the source owner. */
@Component({
  selector: 'phms-notice-diagnostics',
  standalone: true,
  imports: [UiButtonDirective],
  templateUrl: './notice-diagnostics.component.html',
  styleUrl: './notice-diagnostics.component.scss',
})
export class NoticeDiagnosticsComponent {
  @Input() diagnostics: readonly NoticeDiagnostic[] = [];
  @Input() composition: NoticeComposition | null = null;
  @Input() catalog: NoticeCatalog | null = null;
  @Input() disabled = false;
  @Output() readonly navigate = new EventEmitter<NoticeDiagnosticNavigation>();
  @ViewChild('issues') private issues?: ElementRef<HTMLDetailsElement>;

  resolve(diagnostic: NoticeDiagnostic): NoticeDiagnosticResolution {
    return resolveDiagnosticTarget(diagnostic, this.composition, this.catalog);
  }

  goTo(diagnostic: NoticeDiagnostic, target: NoticeDiagnosticTarget): void {
    if (this.disabled || !this.diagnostics.includes(diagnostic)) return;
    // A previously rendered button must never navigate using a stale source locator.
    const current = this.resolve(diagnostic).targets.find(
      (candidate) => JSON.stringify(candidate) === JSON.stringify(target),
    );
    if (current) {
      if (this.issues) {
        this.issues.nativeElement.open = false;
        this.issues.nativeElement.querySelector('summary')?.focus();
      }
      this.navigate.emit({ diagnostic, target: current });
    }
  }
}
